import {Button, Input, Switch, Upload, message, Modal} from 'antd';
import {UploadOutlined} from "@ant-design/icons";
import CustomButton from "../../../components/element/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowCircleDown, faArrowCircleUp, faRemove} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import EntityApi from "../../../api/EntityApi";
import config from '../../../api/config'

const { TextArea } = Input;

const QuestionForm = ({question, index, questions, reload, onSelect, selected}) => {

    const [isEdit, setEdit] = React.useState(false);
    const [formText, setFormText] = React.useState('');
    const [formInfo, setFormInfo] = React.useState('');
    const [formImage, setFormImage] = React.useState('');
    const [viewText, setViewText] = React.useState('');
    const [viewImage, setViewImage] = React.useState('');

    const propsUpload = {
        name: 'file',
        action: config.host + '/api/private/file',
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token')
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log('!!!uploading');
                //console.log(info.file, info.fileList);
                if (info.file.response.content.item !== undefined) {
                    setFormImage(info.file.response.content.item.url);
                }
            }
            if (info.file.status === 'done') {
                message.success(`${info.file.name} file uploaded successfully`);
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
        maxCount: 1
    };

    const onSave = () => {

        if (formText === '') {
            message.error('Введите текст вопроса');
            return false;
        }

        EntityApi.put('private/testing/question/' + question.id, {
            text: formText,
            info: formInfo,
            image: formImage,
        }).then((data) => {
            if (data.status === EntityApi.STATUS_SUCCESS) {
                setViewText(formText);
                setViewImage(formImage);
                setEdit(false);
            }
        }).catch((error) => {
            console.error(error.message());
            message.error('Ошибка сохранения');
        })

    }

    const onConfirmRemove = () => {
        Modal.confirm({
            title: 'Подтвердите удаление вопроса',
            content: 'Вы действительно хотите удалить данный вопрос?',
            onOk: () => {
                onRemove();
            }
        });
    }

    const onRemove = () => {

        EntityApi.delete('private/testing/question', question.id).then((data) => {
            if (data.status === EntityApi.STATUS_SUCCESS) {
                reload();
            }
        }).catch((error) => {
            console.error(error.message());
            message.error('Ошибка удаления');
        })

    }

    const onSort = (id, direction) => {
        EntityApi.post('private/testing/question/sort', id, {
            'direction': direction
        }).then((data) => {
            reload();
        })
    }

    React.useEffect(() => {
        setFormText(question.text);
        setViewText(question.text);
        setFormInfo(question.info);
        setFormImage(question.image);
        setViewImage(question.image);
    }, [])

    return <div className={'flex flex-wrap'}
                style={{marginBottom: '0.75rem', flex: '1 1 100%'}}>

        {
            isEdit &&
            <div className={'w-full'} style={{marginBottom: '0.75rem'}}>
                <div className={'pb-1'}>Текст вопроса</div>
                <TextArea value={formText} onChange={(e) => setFormText(e.target.value)}/>
                <div className={'pt-1'}>
                    <div className={'pb-1'}>Информация</div>
                    <TextArea value={formInfo} onChange={(e) => setFormInfo(e.target.value)}/>
                </div>
                <div className={'flex pt-3 justify-between w-full'}>
                    {
                        formImage &&
                        <div className={'pr-3'}>
                            <img style={{maxHeight: '50px', maxWidth: '100%'}}
                                 src={formImage}/>
                        </div>
                    }
                    <div>
                        <Upload {...propsUpload}>
                            <Button icon={<UploadOutlined/>}>Загрузить изображение
                                вопроса</Button>
                        </Upload>
                    </div>
                    <div style={{flex: '1'}} className={'text-right'}>
                        <Button type={'primary'} onClick={onSave}>Сохранить</Button>
                    </div>
                </div>
            </div>
        }
        {
            !isEdit &&
            <div onClick={() => setEdit(true)}
                 className={'btn bg-slate-150 hover:bg-slate-200 flex w-full mr-3 flex-1'}>
                {
                viewImage &&
                    <div style={{width: '100px'}} className={'pr-3'}>
                        <img style={{maxHeight: '50px', maxWidth: '100%'}}
                             src={viewImage}/>
                    </div>
                }
                <div className={'w-full'}>
                    {viewText}
                </div>
            </div>
        }
        {
            !isEdit &&
            <div className={'mr-3'}>
                <div>
                    {
                        index > 0 ?
                            <CustomButton onClick={() => onSort(question.id, 'down')}
                                          text={<FontAwesomeIcon icon={faArrowCircleUp}/>}
                                          type={"info"}/>
                            :
                            <CustomButton
                                text={<FontAwesomeIcon icon={faArrowCircleUp}/>}
                                disabled={true} type={"default"}/>
                    }
                </div>
                <div className={'mt-2'}>
                    {
                        index < questions.length - 1 ?
                            <CustomButton onClick={() => onSort(question.id, 'up')}
                                          text={<FontAwesomeIcon icon={faArrowCircleDown}/>}
                                          type={"info"}/>
                            :
                            <CustomButton
                                text={<FontAwesomeIcon icon={faArrowCircleDown}/>}
                                disabled={true} type={"default"}/>
                    }
                </div>
            </div>
        }
        {
            !isEdit &&
            <div>
                <div>
                    <CustomButton
                        onClick={onSelect} text={<div style={{fontSize: '8pt'}}>Ответы ({question.answers_count})</div>}
                        type={selected ? 'primary' : 'default'}/>
                </div>
                <div className={'mt-1'}>
                    <CustomButton onClick={onConfirmRemove} text={<FontAwesomeIcon icon={faRemove}/>} type={"error"}/>
                </div>
            </div>
        }
    </div>

}


export default QuestionForm;
